import React, { useEffect, useState } from "react";
import { connect } from "react-redux";
import { hideLocation } from '../../../Core/MyLocations/DeleteLocation/action'
import styles from "../../../Assets/Styles/Components/Book/Map/mylocations.module.css";

const MyLocations = props => {
  const { onClose, show, addresses, onSave } = props;
  const [addressSelected, setAddressSelected] = useState({ city_name: "", detail: "", lat: 0, long: 0 })
  return (
    <div
      className={`${styles.addressesContainer} ${show ? styles.show : ""}`}
      onClick={onClose}
    >
      <div
        className={styles.container}
        onClick={e => {
          e.stopPropagation();
        }}
      >
        <div className={styles.title}>
          <div className={styles.titleName}>آدرس‌های من</div>
          <div className={styles.closeBtn} onClick={onClose} />
        </div>
        <div className={styles.content}>
          {addresses?.length>0 && addresses.map(a => (
          <div key={a.detail+a.city_name+a.lat+a.long} className={`${styles.address} ${(a.city_name===addressSelected.city_name && a.detail===addressSelected.detail && a.lat===addressSelected.lat && a.long===addressSelected.long) ? styles.selected : ""}`} onClick={_ => setAddressSelected(a)}>
            <div className={styles.selectionCircle} />
            <div className={styles.text}>
              <p>{a.city_name}</p>
              <p>{a.detail}</p>
            </div>
            <div
              className={styles.closeBtn}
              onClick={_ => {
                props.hideLocation({ lat: a.lat, long: a.long, detail: a.detail })
                if (a.city_name===addressSelected.city_name && a.detail===addressSelected.detail && a.lat===addressSelected.lat && a.long===addressSelected.long) {
                  setAddressSelected({ city_name: "", detail: "", lat: 0, long: 0 })
                }
              }}
            />
          </div>
          ))}
        </div>
        <div className={styles.bottomBar}>
          <div className="container">
            <div className="row">
              <button
                type="button"
                className={`col-12 ${styles.btn}`}
                onClick={_ => {
                  onSave(addressSelected);
                }}
                disabled={addressSelected.lat === 0}
              >
                <b>انتخاب</b>
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default connect(state => state, { hideLocation }) (MyLocations);
